import { colors } from '../../../theme';
import { zIndex } from '../../../theme/z-index';
import { createOwnUpStyle } from '../../style';
/**
 * Wrapper around the whole modal window. Centered
 *   horizontally and 30% from the top. Also forces
 *   a z-index.
 */

export var OwnUpModalStyle = createOwnUpStyle({
  backgroundColor: colors.BACKGROUND,
  borderRadius: '7px',
  boxShadow: '0px 2px 50px rgba(50, 50, 50, 0.4)',
  position: 'fixed',
  top: '10%',
  right: '10%',
  left: '10%',
  bottom: '10%',
  zIndex: zIndex.ModalWindow,
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
  variants: {
    smallAndDown: {
      borderRadius: 'unset',
      boxShadow: 'unset',
      top: 0,
      right: 0,
      left: 0,
      bottom: 0
    }
  }
});
/**
 * Greyed out background that renders over the page
 *   when the modal is opened.
 */

export var OwnUpModalBackdropStyle = createOwnUpStyle({
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  position: 'fixed',
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
  zIndex: zIndex.ModalBackdrop
});
/**
 * Whitespace for the top section of the modal.
 */

export var OwnUpModalHeaderStyle = createOwnUpStyle({
  padding: '30px 40px 0px 40px'
});
/**
 * Whitespace for the bottom section of the modal.
 */

export var OwnUpModalBodyStyle = createOwnUpStyle({
  flex: 1,
  margin: '30px'
});
/**
 * Container for all the bottom buttons.
 */

export var OwnUpModalFooterStyle = createOwnUpStyle({
  margin: '30px',
  textAlign: 'end',
  '& > button': {
    minWidth: '132px',
    minHeight: '49px',
    marginLeft: '10px'
  }
});
/**
 * X button style.
 */

export var OwnUpModalXButtonStyle = createOwnUpStyle({
  background: 'transparent',
  border: 'none',
  position: 'fixed',
  right: 'calc(10% + 30px)',
  top: 'calc(10% + 30px)',
  cursor: 'pointer',
  variants: {
    smallAndDown: {
      top: '30px',
      right: '30px'
    }
  }
});